export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14080.9d28f881.jpg";